import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pager({ page, pages, total, onPage, testid = "pager" }) {
  if (!pages || pages <= 1) return total != null ? <div className="text-xs text-slate-500 mt-3">{total} record(s)</div> : null;
  return (
    <div data-testid={testid} className="flex items-center gap-2 mt-4 text-sm">
      <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}><ChevronLeft size={14} /></Button>
      <span>Page {page} of {pages}</span>
      <Button size="sm" variant="outline" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}><ChevronRight size={14} /></Button>
      <span className="text-xs text-slate-500 ml-2">{total} record(s)</span>
    </div>
  );
}

export const STATUS_BADGE = {
  pending: "bg-amber-100 text-amber-800", in_progress: "bg-sky-100 text-sky-800", completed: "bg-emerald-100 text-emerald-800", overdue: "bg-rose-100 text-rose-800",
  draft: "bg-slate-100 text-slate-700", pending_approval: "bg-amber-100 text-amber-800", pending_principal: "bg-orange-100 text-orange-800", published: "bg-emerald-100 text-emerald-800", rejected: "bg-rose-100 text-rose-800",
  not_submitted: "bg-rose-100 text-rose-800",
};
export const label = (s) => (s || "").replace(/_/g, " ");
export const todayStr = () => new Date().toLocaleDateString("en-CA");
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
